import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'debitAccountId',
    label: 'Debit account',
    sortable: true,
  },
  {
    name: 'creditAccountId',
    label: 'Credit account',
    sortable: true,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: true,
  },
  {
    name: 'sumBaseCurrency',
    label: 'Amount in BC',
    sortable: true,
  },
  {
    name: 'revaluateDate',
    label: 'Date',
    sortable: true,
  },
];

export const columnsLabels = {
  sumBaseCurrency: 'Amount in BC',
  creditAccountId: 'Credit account',
  currencyId: 'Currency',
};

export const defaultSorter = {
  sortProp: columns[5].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  sumBaseCurrency: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  creditAccountId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  accountId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  roundDecimals: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  revaluateDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['revaluateDateFrom', 'revaluateDateTo'],
  },
  revaluateDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  revaluateDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'sumBaseCurrency',
    type: FilterType.TEXT,
    placeholder: 'Enter sum in bc...',
  },
  {
    name: 'creditAccountId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'currencyId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by currency...',
  },
];
